import { LogoutComponent } from './logout/logout.component';

export const components = [LogoutComponent];

export * from './language-switcher/language-switcher.component';
export * from './logout/logout.component';
